/* eslint-disable no-undef */
import { useState } from 'react';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { loginRequest } from '../config/authConfig';
import { callMsGraph } from './graph';
import { useDispatch, useSelector } from 'react-redux';
import {
    setUserDetails,
    setIsAuthenticatedWithHybris,
    login,
} from 'src/common/redux/actions';
import { validateUserRole, checkImpersonationActive, getWcmsHostName } from 'src/utils/util';
import { getAuthConfig } from 'src/utils/authConfig';
import { useHistory } from 'react-router-dom';
import { getUrlparams } from 'src/utils/util.js';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

// eslint-disable-next-line no-unused-vars
const AccessToken = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const isAuthenticated = useIsAuthenticated();
    const { instance, accounts } = useMsal();
    const [, setAccessToken] = useState(null);
    const hybrisUserDetails = useSelector(
        (state) => state.loginReducer.hybrisUserDetails
    );

    useEffectWithErrorLogging(() => {
        if (isAuthenticated) {
            const request = {
                ...loginRequest,
                account: accounts[0],
            };

            instance
                .acquireTokenSilent(request)
                .then((response) => {
                    setAccessToken(response.accessToken);
                    // On-prem: store MSAL token so interceptor sends it as Bearer for token API
                    if (!getAuthConfig().useBasicAuth) {
                        localStorage.setItem('authToken', response.accessToken);
                    }
                    dispatch(login({
                        ssoToken: response.accessToken,
                        isLoginFlow: false,
                    }));
                })
                .catch(() => {
                    instance.acquireTokenPopup(request).then((response) => {
                        setAccessToken(response.accessToken);
                        callMsGraph(response.accessToken).then((response) => {
                            dispatch(setUserDetails(response));
                        });
                    });
                });
        }
    }, [isAuthenticated]);

    let query = getUrlparams();
    useEffectWithErrorLogging(() => {
        const principalUser =
            sessionStorage.getItem('impersonatedUserId') === null
                ? 'null'
                : sessionStorage.getItem('impersonatedUserId'); // id from session
        const impersonatedUserId =
            query.get('impersonatedUser') === null
                ? 'null'
                : query.get('impersonatedUser'); // id from url

        if (
            hybrisUserDetails.employeeRole ||
            (principalUser !== 'null' && impersonatedUserId !== 'null')
        ) {
            if (
                validateUserRole(hybrisUserDetails.employeeRole) ||
                (principalUser !== 'null' && impersonatedUserId !== 'null')
            ) {
                dispatch(setIsAuthenticatedWithHybris(true));
                localStorage.setItem('userAuthenticated', true);
                if (
                    principalUser !== 'null' &&
                    impersonatedUserId !== 'null' &&
                    !checkImpersonationActive()
                ) {
                    history.push(
                        `/ImpersonationLanding?impersonatedUser=${principalUser}`
                    );
                } else if (
                    principalUser !== 'null' &&
                    impersonatedUserId !== 'null' &&
                    checkImpersonationActive()
                ) {
                    // don't do any redirection
                } else {
                    // history.push('/');
                }
            } else {
                window.location.href = getWcmsHostName();
            }
        } else {
            dispatch(setIsAuthenticatedWithHybris(false));
            localStorage.removeItem('userAuthenticated');
        }
    }, [hybrisUserDetails]);

    return '';
};

export default AccessToken;
